import type { UseFormReturn } from 'react-hook-form'

import { httpService } from '@/api/v1/http.service'
import i18n from '@/i18n'

import type { CourseFormPayload } from '../constants/course-payload'

export const validateNameUniqueness = async ({
  form,
  courseId
}: {
  form: UseFormReturn<CourseFormPayload>
  courseId?: string
}) => {
  form.trigger('name')
  const name = form.getValues('name')
  const educationLevel = form.getValues('educationLevel')

  if (!name || !educationLevel) return true

  const response = await httpService.panel.panelCoursesCheckNameTakenCreate({
    education_level: educationLevel,
    name,
    excluded_course: courseId
  })
  if (!response.is_taken) return true

  form.setError('name', {
    message: i18n.t('help.name-taken', { ns: 'common' })
  })
  return false
}
